import styled from "styled-components"

const ReportSummaryPercentIndicatorInfoItemWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export default ReportSummaryPercentIndicatorInfoItemWrapper